import { render } from "./PrivatePage.vue?vue&type=template&id=47cd7a3c"
import script from "./PrivatePage.vue?vue&type=script&lang=js"
export * from "./PrivatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__